/* global console require document */

import page from "page";
import $ from "jquery";
import { bindCommentsOverlay } from "./commentsOverlay.js";

if (page === "explore-the-archive") {
  // Only start the faceted list and freetext search
  require("./faceted-list.js");
  require("./latest-comments.js");
  require("./freetext-search.js");
} else {
  // Start the archive flow
  bindCommentsOverlay();
  require("./archive/archive.js");
}



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/explore-the-archive.js